import styled from 'styled-components';

export const Video = styled.video`
  margin-bottom: 32px;
  width: 100%;
`;

export const Thumbnail = styled.img`
  position: absolute;
  z-index: 1;
  pointer-events: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const VideoWrapper = styled.div`
  position: relative;
  button {
    z-index: 9;
  }
`;

export const VideoTitle = styled.h3`
  font-size: 26px;
  line-height: 30px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 8px;
  font-weight: 600;
`;

export const VideoPublishedAt = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 32px;
  font-weight: 400;
`;
